export {default as blob} from "./blob";
export {default as buffer} from "./buffer";
export {default as dsv, csv, tsv} from "./dsv";
export {default as image} from "./image";
export {default as json} from "./json";
export {default as text} from "./text";
export {default as xml, html, svg} from "./xml";



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-fetch/src/index.js
// module id = 1430
// module chunks = 0